import { useQuery } from 'react-query';
import { fetchItemCertificate } from 'src/services/courses';

export const useItemCertificates = (type: string, id: number) => {
  return useQuery('item-certificates', () => fetchItemCertificate(type, id));
};
